import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { cn } from '@bem-react/classname';
import { fetchDeletePlatform } from 'store/action/platforms';

import { Button, Subtitle, Title } from 'components';

import './DeletePlatform.scss';

const CnDeletePlatform = cn('deletePlatform');

export const DeletePlatform: React.FC = () => {
    const location = useLocation();
    const state = location.state as { name: string; token: string; id: string };

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const deleteClickHandler = () => {
        navigate(location.pathname);

        dispatch(fetchDeletePlatform(state.id));
    };

    const cancelClickHandler = () => {
        navigate(location.pathname, { state });
    };

    return (
        <div className={CnDeletePlatform()}>
            <div className={CnDeletePlatform('header')}>
                <Title size="xs">Удалить платформу</Title>
                <Subtitle size="m">{state?.name}</Subtitle>
            </div>

            <div className={CnDeletePlatform('actions')}>
                <Button onClick={deleteClickHandler} view="primary" size="m">
                    Удалить
                </Button>

                <Button onClick={cancelClickHandler} view="secondary" size="m">
                    Отмена
                </Button>
            </div>
        </div>
    );
};
